<template>
	<!-- <InputText class="w50pct" v-model="" :default="" :matchType="" :verification="'notEmpty'" :errorMode="'right'" :max-length="200"></InputText> -->
	<div class="posR fsLv2 lh1" :class="styleType">
		<input
			v-if="textArea == false"
			:name="name"
			:type="myType"
			:class="[
				'bgWidget boxR-light',
				addClass,
				sizeClass,
				{
					error: isError.error || error != '',
					bdIpnut:
						styleType != 'noBorder' &&
						stage.browser.mobile == false,
					bdAlpha: stage.browser.mobile,
					[inpPr]: true,
					nS: !searchBtn,
				},
			]"
			class="w100pct tra-fast"
			:placeholder="placeholder"
			:autocomplete="autocomplete"
			v-model.trim="text"
			:only="only"
			:maxLength="maxLength"
			@blur="blur"
			@focus="focus"
			@keyup="keyup"
			@keypress.enter="onEnter(text)"
			@input="handleInput"
			@click.stop="click"
			:readonly="readonly"
			:disabled="disabled"
		/>
		<textarea
			v-if="textArea"
			:name="name"
			:class="[
				'bgWidget boxR-light',
				addClass,
				{
					error: isError.error || error != '',
					bdIpnut:
						styleType != 'noBorder' &&
						stage.browser.mobile == false,
					bdAlpha: stage.browser.mobile,
					pr5x: clearBtn && text && searchBtn,
					pr2x: clearBtn && text && !searchBtn,
					pr3x:
						(!(clearBtn && text) && searchBtn) ||
						type == 'password',
					nS: !searchBtn,
				},
			]"
			class="w100pct h100pct tra-fast"
			:placeholder="placeholder"
			:autocomplete="autocomplete"
			v-model.trim="text"
			:only="only"
			:maxLength="maxLength"
			@blur="blur"
			@focus="focus"
			@keyup="keyup"
			@input="handleInput"
			@click.stop="click"
			:readonly="readonly"
			:disabled="disabled"
		></textarea>
		<div
			v-if="verifyMethod === 'notPassFromOutSide' && error"
			:class="{
				'errorTip-right': errorMode == 'right',
				'errorTip-static': errorMode == 'static',
			}"
			class="errorTip tra-fast"
		>
			{{ error }}
		</div>
		<div v-else class="errorTip tra-fast" v-show="isError.error">
			{{ errorTip }}
		</div>
		<button
			v-if="type == 'password'"
			class="passwordPlug fs14x pr05x cSub"
			@click="changeType"
			type="button"
		>
			<i v-if="passwordMode == 'show'" class="fa fa-eye"></i>
			<i v-if="passwordMode == 'hide'" class="fa fa-eye-slash"></i>
		</button>
		<button
			v-if="clearBtn && text"
			:class="{ mr4x: searchBtn }"
			class="inputBtnPlug pr1x cSub hover-c-error"
			@click.stop="clearInput"
			type="button"
		>
			<Icon v-if="text" name="close" class="w1x h1x" :type="'font'" />
		</button>
		<button
			v-if="searchBtn"
			class="submitBtnPlug bdSub-left pl1x pr1x fSub hover-f-primary"
			@click.stop="onEnter()"
			type="button"
		>
			<i class="fa fa-search"></i>
		</button>
		<div v-if="unit" class="taR posA colC unit" :class="unitMar">
			{{ unit }}
		</div>
		<slot></slot>
	</div>
</template>
<script>
// import {debounce} from '@/util/index'
import { getLanguageStr } from "@/util/language.js";
import * as lib from "@/util/lib.js";

function reg(val, format) {
	val = String(val);
	let valsub;
	let absFlag = true;
	switch (format) {
		case "upInt":
			val = val.replace(/[^\d]/g, "");
			break;
		case "float2":
			let rex = new RegExp(
				"([0]{1}[.]{0,1}[0-9]{0,2}$)|([1-9]{1}[0-9]{0,}[.]{1}[0-9]{0,2})|([1-9][0-9]{0,}$)|([0]{1}$)"
			);
			val = val.match(rex) === null ? null : val.match(rex)[0];
			val = val === null ? null : val;

			break;
		case "int":
			val = val.replace(/[^-\d]/g, "");
			// val=val.match(/[^-\d]/);
			break;
		case "absInt":
			val = val.replace(/\D/g, "");
			if (val) val = Number(val);
			break;
		case "number":
			val = val.replace(/[^-\.0-9]/g, "");
			//判断第一位是不是 -
			//去掉多余的 -
			if (val.substr(0, 1) == "-") {
				//是负数
				val = val.replace(/\-/g, "");
				absFlag = false;
			} else {
				val = val.replace(/\-/g, "");
			}
			//去掉多余的.
			valsub = val.substr(val.indexOf(".") + 1);
			valsub = valsub.replace(/\./g, "");
			val = val.substr(0, val.indexOf(".") + 1) + valsub;
			if (val.substr(0, 1) == ".") val = "0" + val;
			//是负数加上 -
			if (!absFlag) val = "-" + val;
			break;
		case "absNumber":
			val = val.replace(/[^\.0-9]/g, "");
			//去掉多余的.
			valsub = val.substr(val.indexOf(".") + 1);
			valsub = valsub.replace(/\./g, "");
			val = val.substr(0, val.indexOf(".") + 1) + valsub;
			if (val.substr(0, 1) == ".") val = "0" + val;
			break;
		case "tel":
			val = val.replace(/[^-0-9]/g, "");
			break;
		case "mobile":
			val = val.replace(/\D/g, "");
			break;
		case "username": //仅支持空格._-
			// val=val.replace(/[^_0-9a-zA-Z]/g,"");
			val = val.replace(
				/[\f\n\r\t\v`~!#$%^&*()=+\[\]\{\}\\|;:'",<>/?]/g,
				""
			); //\s
			// val=val.split(" ").join("");
			break;
		case "percent":
			val = val.replace(/[^\.0-9]/g, "");
			break;
		case "ip":
			val = val.replace(/[^\.0-9]/g, "");
			break;
		case "verificationCode":
			val = val.replace(/\D/g, "");
			break;
		case "sn":
		case "NMI":
			val = val.replace(/[^A-Za-z0-9]/g, "");
			val = val.toUpperCase();
			break;
		default:
			val = val.toString() == "null" ? "" : val; //去除默认回显null
			val = val.replace(/(^\s*)|(\s*$)/g, ""); // 去除首尾空格
	}
	return val;
}
function match(val, format) {
	val = String(val);
	switch (format) {
		case "floor1x":
			if ($.isNumeric(val)) {
				val = val.match(/-?\d+(\.(\d{1,1}))?/)[0];
				val = Number(val);
			}
			break;
		case "floor2x":
			if ($.isNumeric(val)) {
				val = val.match(/-?\d+(\.(\d{1,2}))?/)[0];
				val = Number(val);
			}
			break;
		case "floor2xPlan":
			if ($.isNumeric(val)) {
				val = val.match(/-?\d+(\.(\d{1,2}))?/)[0];
				val = Number(val);
			}
			break;
		case "floor3x":
			if ($.isNumeric(val)) {
				val = val.match(/-?\d+(\.(\d{1,3}))?/)[0];
				val = Number(val);
			}
			break;
		case "floor4x":
			if ($.isNumeric(val)) {
				val = val.match(/-?\d+(\.(\d{1,4}))?/)[0];
				val = Number(val);
			}
			break;
		case "percent":
			if ($.isNumeric(val)) {
				if (val.match(/^(0|[1-9]\d|100)(\.\d{1,2})?$/)) {
					val = val.match(/^(0|[1-9]\d|100)(\.\d{1,2})?$/)[0];
				} else {
					if (val.indexOf(".") != -1) {
						if (val.indexOf(".") == 0) {
							val = val.substring(1, val.length);
						} else if (val.indexOf(".") == val.length - 1) {
							val = val.substring(0, val.length - 1);
						} else {
							val = val.substring(0, val.indexOf(".") + 3);
						}
					}
				}
				if (Number(val) > 100) {
					val = "100";
				}
			}
			break;
		case "sn":
			val = val.toUpperCase();
			if (val.match(/[A-Z0-9]{1,16}/)) {
				val = val.match(/[A-Z0-9]{1,16}/)[0];
			}
			break;
	}
	return val;
}
export default {
	name: "InputText",
	components: {},
	props: {
		value: {
			// type: String,
			default: "",
		},
		default: {
			type: [Number, String],
			default: "",
		},
		name: {
			type: String,
			default: "",
		},
		type: {
			type: String,
			default: "text",
		},
		addClass: {
			type: [String, Object],
			default: () => ({}),
		},
		size: {
			type: String,
			default: "m",
		},
		isError: {
			type: Object,
			default: () => ({ error: false }),
		},
		placeholder: {
			type: String,
			default: "",
		},
		autocomplete: {
			type: String,
			default: null,
		},
		only: {
			//允许输入的类型
			type: String,
			default: null,
		},
		outType: {
			//输出格式
			type: String,
			default: "",
		},
		matchType: {
			//修正规则
			type: String,
			default: "",
		},
		verification: {
			//失焦验证规则
			type: String,
			default: "",
		},
		maxLength: {
			type: [Number, String],
			default: 50,
		},
		// blur:{
		// 	type:Function,
		// 	default:function(){}
		// },
		fn: {
			type: Function,
			default: function () {},
		},
		readonly: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		clearBtn: {
			//清除关键字按钮 x
			type: Boolean,
			default: false,
		},
		searchBtn: {
			type: Boolean,
			default: false,
		},
		errorTip: {
			type: String,
			default: "",
		},
		fillText: {
			//补充到词条填充的文本
			type: String,
			default: "",
		},
		errorMode: {
			//指明tip呈现方位
			type: String,
			default: "down",
		},
		verifyMethod: {
			type: String,
			default: "notPassFromOutSide", //默认验证显示方式
		},
		styleType: {
			//专有样式:noBorder
			type: String,
			default: "",
		},
		textArea: {
			//是否以多行文本框展示
			type: Boolean,
			default: false,
		},
		unit: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			stage,
			text: this.value,
			myDefault: this.default,
			myType: this.type,
			passwordMode: "hide",
			error: this.errorTip,
			// tipDirClass:""//tip显示的方位
		};
	},
	watch: {
		text(val) {
			val = reg(val, this.only);
			// if(this.type!="password"&&$.isNumeric(val)&&val.includes(".")==false) val=Number(val);//sha256处理字符和数字会有不同的结果
			if (this.outType == "number" && val.includes(".") == false)
				val = Number(val);
			this.$emit("input", val);
			this.$set(this, "text", val);
			// this.doVerification();
		},
		value(val) {
			this.$set(this, "text", reg(val, this.only));
		},
		errorTip: function () {
			this.error = this.errorTip;
		},
	},
	// directives: {
	// 	numberOnly: {
	// 		bind: function(el) {
	// 			el.handler = function() {
	// 				el.value = el.value.replace(/\D+/, '')
	// 			}
	// 			el.addEventListener('input', el.handler)
	// 		},
	// 		unbind: function(el) {
	// 			el.removeEventListener('input', el.handler)
	// 		}
	// 	}
	// },
	created() {
		// this.$watch('text',function(newVal){
		// 	this.$emit("input",newVal);
		// });
		// this.$watch('text', debounce((newKeyword) => {
		// 	this.$emit('input', newKeyword)
		// 	// this.model=newKeyword;
		// }, 300))
	},
	methods: {
		reset: function () {
			this.error = this.errorTip;
			this.text = this.value;
		},
		doVerification: function () {
			let optionArray = this.verification.split(",");
			let $this = this;
			let sOut = []; //用于每个细则遍历，或的判断
			$.each(optionArray, function () {
				let option = this.split(":");
				switch (option[0]) {
					case "notEmpty":
						if (lib.validValue($this.text, ["empty"]).allClear) {
							$this.error = i18n.t("fill3rd145", [
								$this.fillText,
								"x不能为空",
							]);
							return false;
						} else $this.error = "";
						break;
					case "isMobile":
						if (
							lib.validValue($this.text, ["notMobile"]).allClear
						) {
							$this.error = getLanguageStr(
								"phrase19",
								"手机号格式不正确"
							);
							return false;
						} else $this.error = "";
						break;
					case "isMobileInternational":
						if (String($this.text).length < 6) {
							$this.error = getLanguageStr(
								"phrase19",
								"手机号格式不正确"
							);
							return false;
						} else $this.error = "";
						break;
					case "isEmail":
						if (lib.validValue($this.text, ["notEmail"]).allClear) {
							$this.error = getLanguageStr(
								"phrase18",
								"邮箱格式不正确"
							);
							return false;
						} else $this.error = "";
						break;
					case "isEmailOrMobile":
						if (
							lib.validValue($this.text, ["notEmail"]).allClear &&
							lib.validValue($this.text, ["notMobile"]).allClear
						) {
							$this.error = getLanguageStr(
								"phrase20",
								"邮箱或手机号格式不正确"
							);
							return false;
						} else $this.error = "";
						break;
					case "isUsername":
						// if(lib.validValue($this.text,["notUsername"]).allClear) {$this.error=getLanguageStr("phrase18","用户名格式错误");return false;}
						// else $this.error=$this.errorTip;
						$this.error = "";
						break;
					case "<=":
						if ($.isNumeric(option[1])) {
							if (!(Number($this.text) <= Number(option[1]))) {
								$this.error = i18n.t("fill3rd70", [
									option[1],
									"值不能超过",
								]);
								return false;
							} else $this.error = "";
						}
						break;
					case "~":
						// let interval=;
						sOut = [];
						$.each(option[1].split("|"), function (index, value) {
							let area = value.split("~");
							if (
								!(Number($this.text) <= Number(area[1])) ||
								!(Number($this.text) >= Number(area[0]))
							) {
								sOut.push(false);
							} else sOut.push(true);
						});
						if (sOut.indexOf(true) >= 0) $this.error = "";
						else
							$this.error =
								getLanguageStr("all50", "输入范围") +
								":" +
								option[1];
						break;
					case "length":
						let limit = option[1].split("~");
						if (
							!(String($this.text).length >= Number(limit[0])) ||
							(limit.length > 1 &&
								!(
									String($this.text).length <=
									Number(limit[1])
								))
						) {
							$this.error = i18n.t("fill3rd99", [
								limit[0],
								limit[1],
								"密码({0}~{1}个字符)",
							]);
							return false;
						} else $this.error = "";
						break;
					case "password":
						// if(lib.validValue(String($this.text),["notPassword"]).allClear) {$this.error=i18n.t('fill3rd99',['6','50','密码({0}~{1}个字符)']);return false;}
						if (
							lib.validValue(String($this.text), ["notPassword"])
								.allClear
						) {
							$this.error = i18n.t("phrase126", [
								"密码至少6位字符",
							]);
							return false;
						} else $this.error = "";
						break;
					case "notSn":
						if (lib.validValue($this.text, [option[0]])) {
							$this.error = getLanguageStr(
								"16位，支持字母(A-Z)或数字(0-9)",
								"16位，支持字母(A-Z)或数字(0-9)"
							);
						} else {
							$this.error = "";
						}
					case "NMI":
						if (
							!lib.validValue(String($this.text), ["NMI"])
								.allClear
						) {
							if (
								!$this.text ||
								String($this.text).length == 10 ||
								String($this.text).length == 0
							) {
								$this.error = "";
							} else if (String($this.text).length < 10) {
								$this.error = getLanguageStr(
									"plant547",
									"NMI格式不正确"
								);
							} else {
								if (!lib.checkNMILastNum(String($this.text))) {
									$this.error = getLanguageStr(
										"plant548",
										"无效的NMI，请重新输入"
									);
								} else {
									$this.error = "";
								}
							}
						} else {
							$this.error = "";
						}
						break;
				}
			});

			let out;
			if (this.error) {
				//验证不通过：false
				out = false;
			} else out = true; //验证通过：true
			if (this.verification && out) this.$emit("input", this.text); //仅对传入验证规则的进行验证输出
			this.$emit("Verification", out);
			return out;
		},
		blur() {
			if (this.matchType) this.text = match(this.text, this.matchType);
			if (this.text === "" && this.text !== this.myDefault)
				this.text = this.myDefault;
			this.doVerification();
			this.$emit("Blur", this.text);
			this.$emit(
				"InputError",
				this.isError.error ? this.errorTip : this.error
			);
		},
		focus() {
			this.$emit("Focus");
		},
		keyup() {
			this.$nextTick(() => {
				this.$emit("Keyup");
			});
		},
		throttleFunc: _.throttle(
			function (val) {
				if (this.fn) {
					this.fn(val);
				} else {
					return () => {};
				}
			},
			500,
			{
				trailing: false,
			}
		),
		onEnter: function (text = this.text) {
			if (this.doVerification()) {
				this.throttleFunc(text);
				this.$nextTick(() => {
					this.$emit("Enter", text);
				});
				//避免按着不放
				$("body").append(
					`<button id="fireFocus" style="position:absolute;opacity:0;">a</button>`
				);
				$("#fireFocus").focus();
				$("#fireFocus").remove();
			}
		},
		click() {
			this.$emit("Click");
		},
		handleInput(e) {
			const value = e.target.value;
			this.text = value;
			this.$emit("Input", value);
		},
		changeType: function () {
			//密码状态的切换
			switch (this.myType) {
				case "text":
					this.myType = "password";
					this.passwordMode = "hide";
					break;
				case "password":
					this.myType = "text";
					this.passwordMode = "show";
					break;
			}
		},
		clearInput: function () {
			//清空text
			// let $this=this;
			// this.text="";
			// if ($this.clearBtn[1]) {
			// 	setTimeout(function() {
			// 		// $this[$this.clearBtn[1]]();
			// 		$this.$emit("AfterClear");
			// 	},0);
			// }
			// this.text="";
			this.$emit("input", "");
			this.$nextTick(() => {
				this.$emit("Keyup");
				this.$emit("AfterClear", this.value);
			});
		},
	},
	computed: {
		sizeClass: function () {
			switch (this.size) {
				case "m":
					return "sizeM";
					break;
				case "l":
					return "sizeL";
					break;
				case "s":
				default:
					return "sizeS";
					break;
			}
		},
		unitMar() {
			const _width = Math.ceil(
				1.5 * this.unit.replace(/[^x00-xFF]/g, "**").length
			); // 获取字节数，支持中文单位
			if (this.clearBtn && this.text && this.searchBtn) {
				return ["mr8x", `w${_width}x`];
			} else if (this.searchBtn) {
				return ["mr4x", `w${_width}x`];
			} else {
				return ["mr105x", `w${_width}x`];
			}
		},
		inpPr() {
			let totle = this.type === "password" ? 3 : 0;
			const _length = Math.ceil(
				1.5 * this.unit.replace(/[^x00-xFF]/g, "**").length
			);
			const prList = [
				{
					e: this.clearBtn && this.text,
					pr: 4,
				},
				{
					e: this.searchBtn,
					pr: 4,
				},
				{
					e: this.unit,
					pr: _length * 2 + 4 < 6 ? 6 : _length * 2 + 4,
				},
			];
			for (let i = 0; i < prList.length; i++) {
				if (prList[i].e) totle += prList[i].pr;
			}
			if (totle) {
				return `pr${totle}x`;
			} else {
				return "";
			}
		},
	},
	mounted() {
		$(this.$el).on("mousedown", function (e) {
			e.stopPropagation();
		});
	},
	destroyed: function () {
		// this.$emit("input",undefined);
		$(this.$el).off("mousedown");
		this.$emit("Destroyed", "");
	},
};
</script>
<style lang="scss" scoped>
.errorTip,
.infoTip {
	padding: 0.25rem 0.5rem 0.4rem 0.5rem;
	opacity: 1;
	&.errorTip-right {
		line-height: 2;
	}
	&.errorTip-static {
		padding: {
			top: 0.3em;
		}
		position: relative;
		text-align: left;
	}
}
.passwordPlug,
.submitBtnPlug {
	position: absolute;
	top: 0;
	right: 0;
	height: 100%;
	&[status="show"] {
		.show {
			display: block;
		}
	}
	&[status="hide"] {
		.hide {
			display: block;
		}
	}
}
.inputBtnPlug {
	position: absolute;
	top: 20%;
	right: 0;
	height: 60%;
}

.noBorder {
	> input {
		border: none;
		&:focus {
			box-shadow: none;
		}
	}
}
.unit {
	right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/InputText.vue